import PropTypes from 'prop-types'

import styles from './HotelGroup.module.scss'

const HotelGroup = ({ hotelName, children }) => (
  <div className={styles.wrapper}>
    <div className={styles.title}>
      {hotelName}
      {/* {hotelName} <span className={styles.bubble}>{children.length}</span> */}
    </div>
    <div className={styles.notifications}>{children}</div>
  </div>
)

HotelGroup.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  hotelName: PropTypes.string
}

export default HotelGroup
